/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { JobStatus } from '../models/JobStatus';

export class DiscoveryJob {
  /**
  * The run ID of the discovery workflow
  */
  'runId': string;
  /**
  * The date the discovery process started
  */
  'startedAt': Date;
  /**
  * The date the discovery process finished
  */
  'finishedAt': Date;
  'status': JobStatus;
  /**
  * An error message if the discovery failed
  */
  'error'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "runId",
      "baseName": "runId",
      "type": "string",
      "format": ""
    },
    {
      "name": "startedAt",
      "baseName": "startedAt",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "finishedAt",
      "baseName": "finishedAt",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "JobStatus",
      "format": ""
    },
    {
      "name": "error",
      "baseName": "error",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DiscoveryJob.attributeTypeMap;
  }

  public constructor() {
  }
}



